import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import useIcons from "../../hooks/useIcons";
import { getRequestClients } from "../../../../redux/actions/autoLombardActions";
import { HInput } from "../../../../validation/HForm";
import "../../styles/autoLombardLayout.scss";
import {requestStatus} from "../../constants/constants";
import {iconNames} from "../../constants/icon-names";

const RequestActions = ({ onFilterChange }) => {
  const dispatch = useDispatch();
  const { getIcon } = useIcons();
  const { requestClients } = useSelector(({ autolombard }) => autolombard.clients);
  const [filters, setFilters] = useState({
    requestNumber: "",
    phone: "",
    clientId: null,
    status: null,
  });
  const [activeFilters, setActiveFilters] = useState({
    requestNumber: false,
    phone: false,
  });

  const handleGetAction = useCallback(
    (value) => {
      if (value.length >= 2) {
        dispatch(
          getRequestClients({
            size: 5,
            page: 1,
            sortBy: "",
            descending: false,
            name: value,
            filters: {},
          })
        );
      }
    },
    [dispatch]
  );

  const handleInputChange = (field) => (e) => {
    const value = e.target.value;
    const formatValue = value.replace('+', '');
    setFilters((prev) => ({ ...prev, [field]: formatValue }));
  };

  const handleSelectChange = (field) => (selectedOption) => {
    setFilters((prev) => ({ ...prev, [field]: selectedOption }));
    onFilterChange(field)(selectedOption?.value || undefined);
  };

  const handleSearch = (field) => () => {
    const value = filters[field];
    if (value.length < 2) return;
    if (value) {
      onFilterChange(field)(value.replace(/[^\d-]/g, ''));
      setActiveFilters((prev) => ({ ...prev, [field]: true }));
    }
  };

  const handleClearField = (field) => () => {
    setFilters((prev) => ({ ...prev, [field]: "" }));
    setActiveFilters((prev) => ({ ...prev, [field]: false }));
    onFilterChange(field)(undefined);
  };

  const handleKeyPress = (e, field) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch(field)();
    }
  };

  const statusOptions = requestStatus.map((status) => ({
    value: status.key,
    label: status.label,
  }));

  return (
    <div className="content-datatable-header-actions d-flex m-b-spacer-2">
      <div className="form-row flex-space-between fullwidth">
        <div className="form-row-item flex-1">
          <div className="form-element">
            <label className="form-element-label nowrap" htmlFor="requestNumber">
              Поиск по номеру заявки
            </label>
            <div className="form-element fullwidth justify-center">
              <HInput
                type="text"
                className="input input-filter"
                placeholder="Введите номер заявки"
                onChange={handleInputChange("requestNumber")}
                onKeyPress={(e) => handleKeyPress(e, "requestNumber")}
                value={filters.requestNumber || ""}
              />
              {activeFilters.requestNumber ? (
                <button
                  className="search-icon"
                  onClick={handleClearField("requestNumber")}
                >
                  {getIcon(iconNames.CROSS)}
                </button>
              ) : (
                <button
                  className="search-icon"
                  onClick={handleSearch("requestNumber")}
                >
                  {getIcon(iconNames.SEARCH)}
                </button>
              )}
            </div>
          </div>
        </div>

        <FilterSelect
          label="Поиск по ФИО клиента"
          options={requestClients}
          placeholder="Введите ФИО клиента"
          value={filters.clientId}
          onChange={handleSelectChange("clientId")}
          onInputChange={handleGetAction}
        />

        <div className="form-row-item flex-1">
          <div className="form-element">
            <label className="form-element-label nowrap" htmlFor="phoneInput">
              Поиск по номеру телефона
            </label>
            <div className="form-element fullwidth justify-center">
              <HInput
                type="tel"
                className="input input-filter"
                placeholder="Формат: 3XXXXXXXXXXX"
                onChange={handleInputChange("phone")}
                onKeyPress={(e) => handleKeyPress(e, "phone")}
                maxLength={15}
                value={filters.phone}
              />
              {activeFilters.phone ? (
                <button
                  className="search-icon"
                  onClick={handleClearField("phone")}
                >
                  {getIcon(iconNames.CROSS)}
                </button>
              ) : (
                <button className="search-icon" onClick={handleSearch("phone")}>
                  {getIcon(iconNames.SEARCH)}
                </button>
              )}
            </div>
          </div>
        </div>

        <FilterSelect
          label="Статус"
          placeholder="Выберите статус"
          options={statusOptions}
          value={filters.status}
          onChange={handleSelectChange("status")}
        />
      </div>
    </div>
  );
};

export default RequestActions;

const FilterSelect = ({
  label,
  name,
  placeholder,
  options,
  value,
  onChange,
  onInputChange,
}) => (
  <div className="form-row-item flex-1">
    <div className="form-element">
      <label className="form-element-label" htmlFor={name}>
        {label}
      </label>
      <div className="form-element-data fullwidth">
        <Select
          classNamePrefix="select"
          className="basic-multi-select"
          isSearchable={true}
          placeholder={placeholder}
          options={options}
          value={value}
          onChange={onChange}
          onInputChange={onInputChange}
          noOptionsMessage={() => "Нет результатов"}
          isClearable
        />
      </div>
    </div>
  </div>
);
